var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18185 10C4.18185 9.36489 4.28958 8.756 4.48185 8.18489L1.1164 5.66844C0.460488 6.97244 0.0909424 8.44177 0.0909424 10C0.0909424 11.5569 0.460033 13.0253 1.11503 14.3284L4.47867 11.8071C4.28822 11.2387 4.18185 10.632 4.18185 10Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0909 4.22221C11.5 4.22221 12.7727 4.7111 13.7727 5.5111L16.6818 2.66666C14.9091 1.15555 12.6363 0.222214 10.0909 0.222214C6.13906 0.222214 2.7427 2.4351 1.11633 5.66844L4.48179 8.18488C5.25724 5.87999 7.4677 4.22221 10.0909 4.22221Z",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0909 15.7778C7.4677 15.7778 5.25724 14.12 4.48179 11.8151L1.11633 14.3311C2.7427 17.5649 6.13906 19.7778 10.0909 19.7778C12.53 19.7778 14.8586 18.9298 16.6063 17.3409L13.4118 14.9226C12.5104 15.4786 11.3754 15.7778 10.0909 15.7778Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6364 9.99999C19.6364 9.42221 19.5455 8.79999 19.4091 8.22221H10.0909V12H15.4546C15.1864 13.288 14.4564 14.2782 13.4119 14.9227L16.6064 17.3409C18.4423 15.6724 19.6364 13.1871 19.6364 9.99999Z",
    fill: "#4285F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.d7164a55ac8ed2d49506d10ae8599148.svg";
export { ForwardRef as ReactComponent };